import { SensorStatus } from "./requests";

declare var Turbolinks: any;

export interface UrlHelperConfiguration {
    dashboardTemplate: string;
    sensorDetailsTemplate: string;
    sensorListTemplate: string;
    sensorListAllLocationsTemplate: string;
}

/**
 * See UrlHelperConfiguration.cs
 */
export class UrlHelper {
    constructor(private configuration: UrlHelperConfiguration) {

    }

    public navigate(target: string) {
        Turbolinks.visit(target);
    }

    public formatDashboardUrl(locationId: number): string {
        return this.configuration.dashboardTemplate.replace("999", locationId.toString());
    }

    public formatSensorDetailUrl(sensorId: number): string {
        return this.configuration.sensorDetailsTemplate.replace("999", sensorId.toString());
    }

    public formatSensorUrl(status: SensorStatus, locationId: number): string {
        return this.configuration.sensorListTemplate.replace("888", locationId.toString()).replace("999", status.toString());
    }

    public formatAllLocationsSensorUrl(status: SensorStatus): string {
        return this.configuration.sensorListAllLocationsTemplate.replace("999", status.toString());
    }
}
